import React from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
const DeleteModal = ({
    showDeleteModal, setShowDeleteModal, usernameToDelete, itemId, deleteFunction
}) => {
    const handleClose = () => {
        setShowDeleteModal(false)
    };
    return (
        <>
            <Modal show={showDeleteModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete <b>{usernameToDelete}</b>?</Modal.Body>
                <Modal.Footer>
                    <Button type="submit" className='btn btn-light d-flex align-items-center justify-content-center ms-2' style={{ width: "73.99px" }} onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant="danger" type="submit" className='btn btn-danger d-flex align-items-center justify-content-center ms-2' style={{ width: "73.99px" }} onClick={() => deleteFunction(itemId)}>
                        Confirm
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default DeleteModal;